import {
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import ReportForms from '../ReportForms/index.js'

export const MODAL_FORM = 'task_params_modal'

export function showTaskParamsModal(task) {
  setForm(MODAL_FORM, {
    task,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  const forms = formsSelector(state)

  return forms[MODAL_FORM]
}

function DefaultParamsSummary({params}) {
  return (
    <div
      className="fs-00 lh-md"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(params, null, '--indent--')
          .replace(/\n/g, '<br />')
          .replace(/--indent--/g, '&nbsp;&nbsp;'),
      }}
    />
  )
}

function TaskParamsModal({form: {task}}) {
  const ParamsSummary =
    ReportForms[task.type]?.ParamsSummary || DefaultParamsSummary

  return (
    <ConfirmModal
      title="Task Parameters"
      modalSize="sm-md"
      onCancel={() => closeModal()}
      cancelText="Close"
    >
      <ul className="list list--no-style">
        <li className="list__item--form list__item--wrap-order-report-filters">
          <ParamsSummary type={task.type} params={task.params} viewOnly />
        </li>
      </ul>
    </ConfirmModal>
  )
}

export default onlyIfForm(TaskParamsModal, modalFormSelector)
